import classNames from "classnames";
import styles from "./Memo.module.css";
import StyledButton from "../../common/buttons/StyledButton";
import ValidationMessage from "../../common/ValidationMessage/ValidationMessage";

const strings = {
  placeholder: "Enter Memo",
  saveMemo: "Save Memo",
};

type Props = {
  value: string;
  onChange: (s: string) => void;
  onSaveMemo?: () => void;
  header?: string;
  placeholder?: string;
  isLoading?: boolean;
  className?: string;
  validationMessages?: string[];
};

export default function Memo({
  value,
  onChange,
  onSaveMemo,
  header,
  placeholder,
  isLoading,
  className,
  validationMessages,
}: Props) {
  return (
    <div className={classNames(styles.container, className)}>
      {header ? <div className={styles.header}>{header}</div> : null}
      <textarea
        className={styles.textarea}
        placeholder={placeholder ?? strings.placeholder}
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        disabled={isLoading}
      />
      <div className={styles.footer}>
        {validationMessages ? (
          <ValidationMessage
            className={styles.validationMessages}
            validationMessages={validationMessages}
          />
        ) : null}
        {onSaveMemo ? (
          <StyledButton
            className={styles.saveMemoButton}
            onClick={onSaveMemo}
            disabled={!value}
            isLoading={isLoading}
          >
            {strings.saveMemo}
          </StyledButton>
        ) : null}
      </div>
    </div>
  );
}
